import { mediaMin } from '@spa/shared/theme';
import styled from 'styled-components';

export const Wrapper = styled.ol`
  display: flex;
  align-items: center;
  ${({ theme }) => theme.gap(2)};
  align-self: start;
  flex-wrap: wrap;

  svg {
    width: 8px;
    height: 8px;
  }

  ${mediaMin.mediumBreakpoint`
    align-items: flex-start;
  `}
`;

export const Item = styled.li`
  display: flex;
  align-items: center;
  font-size: ${props => props.theme.rem(16)};
  line-height: ${props => props.theme.rem(26)};
  ${({ theme }) => theme.gap(1)};

  ${mediaMin.mediumBreakpoint`
    font-size: ${props => props.theme.rem(14)};
    line-height: ${props => props.theme.rem(24)};
  `}

  a {
    color: ${props => props.theme.breadcrumbs.text.color};
    text-decoration: none;
  }

  &:hover:not(:last-child) a {
    text-decoration: underline;
  }

  &:last-child {
    color: ${props => props.theme.breadcrumbs.lastItem.color};
  }

  svg {
    width: 15px;
    height: 15px;
  }
`;
